<template>
  <div class="layout-flex">
    <div class="layout-flex-item" @click="handleTabs(1)">
      <img v-show="curIndex!=1" class="item-img" src="../../assets/meb/imgsMobile/MnavCY@2x.png" />
      <img v-show="curIndex==1" class="item-img" src="../../assets/meb/imgsMobile/MnavCY1@2x.png" />
    </div>
    <div class="layout-flex-item" @click="handleTabs(2)">
      <img v-show="curIndex!=2" class="item-img" src="../../assets/meb/imgsMobile/MnavCS@2x.png" />
      <img v-show="curIndex==2" class="item-img" src="../../assets/meb/imgsMobile/MnavCS1@2x.png" />
    </div>
    <div class="layout-flex-item" @click="handleTabs(3)">
      <img v-show="curIndex!=3" class="item-img" src="../../assets/meb/imgsMobile/MnavYQ@2x.png" />
      <img v-show="curIndex==3" class="item-img" src="../../assets/meb/imgsMobile/MnavYQ1@2x.png" />
    </div>
    <div class="layout-flex-item" @click="handleTabs(4)">
      <img v-show="curIndex!=4" class="item-img" src="../../assets/meb/imgsMobile/MnavZZ@2x.png" />
      <img v-show="curIndex==4" class="item-img" src="../../assets/meb/imgsMobile/MnavZZ1@2x.png" />
    </div>
    <div class="layout-flex-item" @click="handleTabs(5)">
      <img v-show="curIndex!=5" class="item-img" src="../../assets/meb/imgsMobile/MnavDC@2x.png" />
      <img v-show="curIndex==5" class="item-img" src="../../assets/meb/imgsMobile/MnavDC1@2x.png" />
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: ["index"],
  data() {
    return {
      curIndex: this.index
    };
  },
  mounted() {
    console.log(this);
  },
  methods: {
    handleTabs(index) {
      this.$parent.$parent.index = index;
    },
    handleBack() {
      this.$router.replace({ name: "meb3" });
    }
  }
};
</script>

<style lang="less" scoped>
.layout-flex {
  width: 375px;
  padding: 20px 10px 20px 10px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  .layout-flex-item {
    margin-left: 30px;
    width: 47px;
    height: 49px;
  }
  .layout-flex-item:first-child {
    margin-left: 0px;
  }
  .item-img {
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
}
</style>
